import { render } from "./VRMovies.vue?vue&type=template&id=0a83d265&scoped=true"
import script from "./VRMovies.vue?vue&type=script&lang=js"
export * from "./VRMovies.vue?vue&type=script&lang=js"

import "./VRMovies.scss?vue&type=style&index=0&id=0a83d265&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a83d265"]])

export default __exports__